namespace advisorop.components.servicer {

    export class OutsideHoldingsListController {

        //input params
        accountId: number;
        enableRtg: boolean;
        onHoldingsRtgChanged: any;
        gridDisabled: number;
        hasRtgHoldings: boolean = false;
        iAmReady: any;
        readyDone: boolean = false;
        account: domains.IAccount;

        holdings: any[];
        dg: DevExpress.ui.dxDataGridOptions;
        allocationRule: any = { type: "range", min: 0, max: 1, message: "Please enter value between 0 (0.00%) and 1 (100.00%)" };

        dgRowsForSaving = [];
        private refreshEventUnsubscribe: () => void;
        dgComponent: DevExpress.ui.dxDataGrid;

        static $inject = ["advisorService", "accountApi", "$rootScope"];
        constructor(private advisorService: services.AdvisorService, private accountApi: services.AccountApi, private $rootScope: ng.IRootScopeService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Holdings"
                },
                bindingOptions: {
                    dataSource: "vm.holdings",
                    "columns[3].allowEditing": "vm.enableRtg"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                height: "250px",
                paging: { pageSize: 200 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                editing: {
                    mode: "batch",
                    allowUpdating: true,
                    allowAdding: true,
                    allowDeleting: true
                },
                columns: [
                    { dataField: "id", caption: "Id", allowEditing: false, allowFiltering: false, visible: false },
                    { dataField: "description", caption: "Holding", allowEditing: true },
                    {
                        dataField: "amount", caption: "Value", allowFiltering: false,
                        format: { type: "fixedPoint", precision: 2 },
                        allowEditing: true
                    },
                    { dataField: "includeInRTG", dataType: "boolean", caption: "Include in RTG", allowEditing: true, visible: this.enableRtg },
                    {
                        dataField: "equityPrc", caption: "Equities", allowFiltering: false,
                        format: { precision: 2, type: "percent" },
                        allowEditing: true, validationRules: [this.allocationRule]
                    },
                    {
                        dataField: "fixedIncomePrc",
                        caption: "Fixed Income", allowFiltering: false,
                        format: { precision: 2, type: "percent" },
                        allowEditing: true,
                        validationRules: [this.allocationRule]
                    },
                    {
                        dataField: "alternativeAssetPrc", caption: "Alternative Assets", allowFiltering: false,
                        format: { precision: 2, type: "percent" },
                        allowEditing: true, validationRules: [this.allocationRule]
                    },
                    {
                        dataField: "cashPrc", caption: "Cash", allowFiltering: false,
                        format: { precision: 2, type: "percent" },
                        allowEditing: true, validationRules: [this.allocationRule]
                    }
                ],
                onInitNewRow: (e) => {
                    e.data.includeInRTG = true;
                },
                onCellPrepared: (e: any) => {
                    if (e.rowType == "data"
                        && (e.column.dataField == "equityPrc" || e.column.dataField == "fixedIncomePrc" ||
                            e.column.dataField == "alternativeAssetPrc" || e.column.dataField == "cashPrc")
                        && e.column.allowEditing) {

                        if (!e.data.includeInRTG) {
                            e.cellElement.html("");
                        }
                        //var inp = e.element.find('input');
                        //inp.prop("disabled", !e.data.includeInRTG);
                    }
                },
                onInitialized: (e) => {
                    this.dgComponent = e.component;
                    this.updateEditingState();
                },
                onRowRemoving: (e: any) => {
                    if (e.key && e.key.id && e.key.id > 0) {
                        this.advisorService.deleteOutsideHoldings(e.data.id)
                            .then(response => {},
                            err => {
                                toastr.error("Error when deleting holdings. ERROR " + err.status + " " + err.data);
                                e.isValid = false;
                                e.errorText = "Error when deleting holdings. ERROR " + err.status + " " + err.data;
                                e.cancel = true;
                            });
                    }
                },

                onRowValidating: (e: any) => {
                    // properties which are not changed will not be in newData record so we must take them from oldData
                    e.newData.accountId = this.accountId;
                    if (e.key && e.key.id) { e.newData.id = e.key.id; } else { e.newData.id = 0; }
                    if (e.oldData) {
                        if (e.newData.description == undefined) e.newData.description = e.oldData.description;
                        if (e.newData.amount == undefined) e.newData.amount = e.oldData.amount;
                        if (e.newData.includeInRTG == undefined) e.newData.includeInRTG = e.oldData.includeInRTG;
                    }

                    if (!e.oldData) e.oldData = {};

                    if (this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT &&
                        (!e.newData.includeInRTG || (e.newData.includeInRTG == undefined && !e.oldData.includeInRTG))) {
                        e.isValid = false;
                        e.errorText = "Include in RTG must be checked because this is a Direct Account";
                        return false;
                    }

                    let alternativeAssetPrc: number = 1*this.getCurrentCellValue(e.newData.alternativeAssetPrc, e.oldData.alternativeAssetPrc);
                    let cashPrc: number = 1*this.getCurrentCellValue(e.newData.cashPrc, e.oldData.cashPrc);
                    let equityPrc: number = 1*this.getCurrentCellValue(e.newData.equityPrc, e.oldData.equityPrc);
                    let fixedIncomePrc: number = 1*this.getCurrentCellValue(e.newData.fixedIncomePrc, e.oldData.fixedIncomePrc);

                    if (e.newData.includeInRTG || (e.newData.includeInRTG == undefined && e.oldData.includeInRTG)) {
                        //console.log("equityPrc:", equityPrc,
                        //    "cashPrc:", cashPrc,
                        //    "fixedIncomePrc:", fixedIncomePrc,
                        //    "alternativeAssetPrc:", alternativeAssetPrc);
                        let totalAllocation: number = <number>equityPrc + <number>cashPrc
                            + <number>fixedIncomePrc + <number>alternativeAssetPrc;
                        //console.log("Total allocation*:", totalAllocation)
                        e.isValid = (totalAllocation == 1);
                        if (!e.isValid) {
                            e.errorText = "Total allocation needs to be 100%. Current allocation is " + totalAllocation*100 + " %";
                            return false;
                        }
                    }

                    e.newData.equityPrc = equityPrc;
                    e.newData.cashPrc = cashPrc;
                    e.newData.fixedIncomePrc = fixedIncomePrc;
                    e.newData.alternativeAssetPrc = alternativeAssetPrc;
                    e.newData.allocations = [];
                    //var batchToSave: any[];
                    this.dgRowsForSaving.push(e.newData);
                    this.advisorService.saveOutsideHoldings(this.dgRowsForSaving)
                        .then(response => {
                            this.holdings = response.data;
                                let hasRtgHoldings = this.holdings.map(f => f.includeInRTG).indexOf(true) >= 0;
                                this.onHoldingsRtgChanged({ hasRtgHoldings: hasRtgHoldings });
                                this.hasRtgHoldings = hasRtgHoldings;
                        },
                        err => {
                            toastr.error("Error when updating allocation. ERROR " + err.status + " " + err.data);
                            e.isValid = false;
                            e.errorText = "Error when updating allocation. ERROR " + err.status + " " + err.data;
                            }).finally(() => {
                            });
                    this.dgRowsForSaving = [];
                },
            }
        };

        getCurrentCellValue(original: any, alternative: any): number {
            //console.log("ORIGINAL", original);
            //console.log("ALTERNATIVE", alternative);

            if (original === undefined) {
                return alternative ? alternative : 0.0;
            } else {
                if (original) return original;
                else if (original == null) return 0.0;

                return alternative ? alternative : 0.0;
            }
        }

        private updateEditingState(): void {
            const disableEditing = !!this.gridDisabled;
            const currentEditing = this.dgComponent ? this.dgComponent.option("editing") : this.dg.editing;
            const newEditing = Object.assign({}, currentEditing, {
                allowUpdating: !disableEditing,
                allowAdding: !disableEditing,
                allowDeleting: !disableEditing
            });

            if (this.dgComponent) {
                console.log('[OutsideHoldingsList] updateEditingState -> applying to component, disableEditing:', disableEditing);
                this.dgComponent.option("editing", newEditing);
            } else {
                console.log('[OutsideHoldingsList] updateEditingState -> setting config before init, disableEditing:', disableEditing);
                this.dg.editing = newEditing;
            }
        }
        
        loadHoldings(): void {
            if (this.accountId > 0 || this.gridDisabled == 1) {

                this.accountApi.getById(this.accountId)
                    .success((data) => {
                        this.account = data;
                    })
                    .error((data, status) => {
                        toastr.error("Error loading account " + status + " " + data);
                    });

                this.advisorService.getOutsideHoldings(this.accountId)
                    .then(response => {
                        this.holdings = response.data;
                        this.hasRtgHoldings = this.holdings.map(f => f.includeInRTG).indexOf(true) >= 0;
                        this.onHoldingsRtgChanged({ hasRtgHoldings: this.hasRtgHoldings });
                        if (this.iAmReady && !this.readyDone) {
                            this.readyDone = true;
                            this.iAmReady({ ctrl: this });
                        }
                    },
                        err => toastr.error("Error when trying to load holdings. ERROR " + err.status + " " + err.data)
                    );
            } else {
                this.holdings = [];
            }
        };
        
        $onInit(): void {
            console.log('[OutsideHoldingsList] $onInit called, accountId:', this.accountId);
            this.updateEditingState();
            
            // Listen for refresh event from account-summary (when manual account is closed)
            this.refreshEventUnsubscribe = this.$rootScope.$on('outsideHoldingsRefresh', (event: ng.IAngularEvent, data: { accountId: number }) => {
                console.log('[OutsideHoldingsList] Received outsideHoldingsRefresh event, data:', data, 'myAccountId:', this.accountId);
                if (data.accountId === this.accountId) {
                    console.log('[OutsideHoldingsList] AccountId matches, refreshing holdings...');
                    this.loadHoldings();
                } else {
                    console.log('[OutsideHoldingsList] AccountId does not match, ignoring event');
                }
            });
        }

        $onDestroy(): void {
            console.log('[OutsideHoldingsList] $onDestroy called, unsubscribing from event');
            if (this.refreshEventUnsubscribe) {
                this.refreshEventUnsubscribe();
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {        
                if ((key == "accountId" && this.accountId > 0) || (key == "gridDisabled" && this.gridDisabled == 1)) {
                    this.loadHoldings();
                }   
            }
            if (evt && evt.gridDisabled) {
                this.updateEditingState();
            }
        }
        
    }
    
    class OutsideHoldingsList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                enableRtg: "<",
                gridDisabled: "<",
                onHoldingsRtgChanged: "&",
                iAmReady: "&"
            };
            this.controller = OutsideHoldingsListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/outside-holdings-list.html";
        }
    }
    angular.module(Constants.APP).component("outsideHoldingsList", new OutsideHoldingsList());

}